import { defineStore } from 'pinia';
import type { FlightStoreState } from '#/flight';
const useFlightStore = defineStore('selected-flight', {
	// 持久化存储，可以根据自己需求配置哈
	state: (): FlightStoreState => ({
		curFlight: {},
		continuePriceVerify: false
	}),
	actions: {
		setCurFlight(flight: any): void {
			this.curFlight = flight;
		},
		setContinuePriceVerify(result: boolean): void {
			this.continuePriceVerify = result;
		},
	},
	getters: {
		getCurFlight(): any {
			return this.curFlight;
		},
		getContinuePriceVerify(): any {
			return this.continuePriceVerify;
		}
	},
	//persist定义要做判断，因为localStorage是客户端参数，所以需要加process.client
	persist: process.client && {
		storage: sessionStorage,
		paths: ['curFlight']
	}
});

export const setCurFlightFun = (flight: any) => {
	useFlightStore().setCurFlight(flight);
};
export const getCurFlightFun = () => {
	return useFlightStore().getCurFlight;
};

export const setContinuePriceVerifyFun = (result: boolean) => {
	useFlightStore().setContinuePriceVerify(result);
};
export const getContinuePriceVerifyFun = () => {
	return useFlightStore().getContinuePriceVerify;
};
